var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "close-on-click-modal": false,
        "show-close": true,
        title: _vm.$t("placeOrder.BatchExport"),
        visible: _vm.dialogVisibleExport,
        top: "10vh",
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibleExport = $event
        },
        close: _vm.clearForm,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "exportRuleForm",
          staticClass: "demo-exportRuleForm",
          attrs: { model: _vm.exportRuleForm, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                rules: {
                  required: true,
                  message: _vm.$t("placeOrder.pleaseInput"),
                  trigger: ["blur", "change"],
                },
                prop: "NumberType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "80%" },
                  model: {
                    value: _vm.exportRuleForm.NumberType,
                    callback: function ($$v) {
                      _vm.$set(_vm.exportRuleForm, "NumberType", $$v)
                    },
                    expression: "exportRuleForm.NumberType",
                  },
                },
                [
                  _vm.activeName === "0"
                    ? [
                        _c("el-option", {
                          key: "1",
                          attrs: {
                            label: _vm.$t("collectionCenter.Barcode"),
                            value: 3,
                          },
                        }),
                        _c("el-option", {
                          key: "2",
                          attrs: {
                            label: _vm.$t("collectionCenter.lanshouOrderNum"),
                            value: 4,
                          },
                        }),
                        _c("el-option", {
                          key: "3",
                          attrs: {
                            label: _vm.$t("collectionCenter.customerOrderNum"),
                            value: 5,
                          },
                        }),
                      ]
                    : [
                        _c("el-option", {
                          key: "2",
                          attrs: {
                            label: _vm.$t("collectionCenter.waybillNumber"),
                            value: 1,
                          },
                        }),
                        _c("el-option", {
                          key: "3",
                          attrs: {
                            label: _vm.$t("GlobalSetObj.ScanNumber"),
                            value: 2,
                          },
                        }),
                      ],
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: {
                rules: {
                  required: true,
                  message: _vm.$t("placeOrder.pleaseInput"),
                  trigger: ["blur"],
                },
                prop: "inputValue",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("orderCenterCont.Multiple"),
                  clearable: "",
                  rows: "6",
                  type: "textarea",
                },
                model: {
                  value: _vm.exportRuleForm.inputValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.exportRuleForm, "inputValue", $$v)
                  },
                  expression: "exportRuleForm.inputValue",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: {
                rules: {
                  required: true,
                  message: _vm.$t("GlobalSetObj.pleaseChoose"),
                  trigger: ["blur"],
                },
                prop: "withImage",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.exportRuleForm.withImage,
                    callback: function ($$v) {
                      _vm.$set(_vm.exportRuleForm, "withImage", $$v)
                    },
                    expression: "exportRuleForm.withImage",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [
                    _vm._v(_vm._s(_vm.$t("trailer.withImages"))),
                  ]),
                  _c("el-radio", { attrs: { label: false } }, [
                    _vm._v(_vm._s(_vm.$t("trailer.withoutImages"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "15px 0" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.dialogVisibleExport = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.comfire },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.CheckItOutNow")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }